// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3Mx_N","gfeWrapper":"CalendarEvent_gfeWrapper__3G34R"};